import { AppSettings } from "booking_app/values/app-settings";
import { CityCountryBuilderService } from "booking_app/services/city-country-builder.service";
import { Tenant } from "booking_app/types";

declare var angular: any;

angular.module("BookingApp").config([
  "$routeProvider", "$injector", "KaligoConfig",
  ($routeProvider, $injector, KaligoConfig) => {
    $routeProvider.when("/company/visa-infinite-about-the-benefit", {
      controller: "PageCtrl",
      templateUrl: "/html/company/faqs2",
    }).when("/terms/visa-infinite-privacy-policy", {
      controller: "PageCtrl",
      templateUrl: "/html/terms/privacy_policy2",
    }).when("/terms/visa-infinite-terms-and-conditions", {
      controller: "PageCtrl",
      templateUrl: "/html/terms/terms_condition2",
    }).when("/terms/privacy", {
      redirectTo: "/terms/visa-infinite-privacy-policy",
    }).when("/terms/terms_condition", {
      redirectTo: "/terms/visa-infinite-terms-and-conditions",
    }).when("/company/faqs", {
      redirectTo: "/company/visa-infinite-about-the-benefit",
    }).when("/company/visa-covid-19", {
      controller: "PageCtrl",
      templateUrl: "/html/company/covid19",
    });
  },
]);

class VisaCtrl {

  static $inject = [
    "$rootScope",
    "AppSettings",
    "SearchSortingService",
    "UtilsService",
    "CityCountryBuilderService",
  ];

  constructor(
    private $rootScope: any,
    private appSettings: AppSettings,
    SearchSortingService,
    private utilsService: any,
    private cityCountryBuilderService: CityCountryBuilderService,
  ) {
    this.appSettings.enableChildrenSearch = true;
    this.appSettings.ratingArray = [5, 4, 3];
    this.appSettings.includeUnavailableInTotalCount = false;
    this.appSettings.preFilterUnavailableHotels = true;
    this.appSettings.redirectMarketRates = false;
    this.appSettings.displayNonBookableMarketRates = true;
    this.appSettings.onlyShowVisaCardLogo = true;
    this.appSettings.checkoutPagePlaceholderText = {
      firstName: "(e.g) John",
      lastName: "Smith",
    };
    this.appSettings.enableSelectionOfDates = true;
    this.appSettings.showCashSlider = false;
    this.appSettings.cdnProcessingURL = "https://visa-hotel-nights.inspiredlifestyles.com";
    this.appSettings.maximumGuestsMessage = {
      showMessage: true,
      maximumGuests: 4,
    };
    this.appSettings.mobileResultPopupConfig = {
      filterIconSource: "visa/temp/filter-icon.png",
      sortIconSource: "visa/temp/sort-icon.png",
      mapIconSource: "visa/temp/map-icon.png",
    };

    this.appSettings.limitedCountryCityOptions = true;
    this.appSettings.tenant = Tenant.VISA;
    this.appSettings.hotelDetailsTemplateConfig.showGroupedActions = false;
    this.appSettings.ccValidationUseCardErrorModal = true;
    this.appSettings.stripePaymentIntentsEnabled = true;

    this.$rootScope.globalState.hideUseAddressFromProfile = true;
    this.$rootScope.globalState.serviceEmail = "service@kaligo.com";
    this.$rootScope.globalState.useSimpleLoader = true;
    this.$rootScope.abTest = { withConfidence: "no" };
    this.$rootScope.landingPage.minBookingDays = 4;
    this.$rootScope.globalState.customLoaderFile = "/html/whitelabel/visa/custom_loader";

    const sortingOptions = [
      "rating-hilo", "rating-lohi", "deal",
      "best-rated", "distance-lohi", "price-lohi",
      "price-hilo",
    ];
    SearchSortingService.initializePermittedSortingOptions(sortingOptions);
    this.cityCountryBuilderService.buildList("visa");
  }

}

angular.module("BookingApp").controller("VisaCtrl", VisaCtrl);
